<template lang="pug">
    a(:href="`/company/${ogrn}`" target="_blank")
        slot
</template>

<style lang="sass" scoped>
@import "styles/global-variables.sass"

a
    @extend .blue-red-hover-text
</style>

<script>
export default {
    // TODO "сделать тултип и статус"
    props: ['ogrn', 'tooltip', 'status-icon']
}
</script>